import React from "react";
import Form from 'react-bootstrap/Form';
import {InputGroup} from "react-bootstrap";

export default function DropdownBar(props) {

    function chn(e) {
        props.onchange(e.target.value);
    }

    return (
        <>
            <InputGroup className="">
                <Form.Select onChange={chn} value={props.value} aria-label="Sorting">
                    {Object.entries(props.option).map(([key,value],index) =>
                        <option key={index} value={key}>{value}</option>
                    )}
                </Form.Select>
            </InputGroup>

        </>
    );
}



